import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../api';
import { RootState } from '../../../../store/rootReducer';
// import HSButton from '../../../common/Button';
import NormalInput from '../../../common/NormalInput';
import PhoneNumber, { PhoneNumberInput } from '../../../common/PhoneNumber';
import MessageActions from '../../../message/redux/actions';
import { emailValidation } from '../../../utils/validation';
import LinkButton from '../../../common/LinkButton';

const Section2Form: React.FC = () => {
    const UUID = useSelector((state: RootState) => state.user.uuid);
    const dispatch = useDispatch();

    const [formFields, setFormFields] = useState<FormField>({
        name: undefined,
        email: undefined,
        phoneNumber: {
            countryCode: '+65',
            number: undefined,
        },
        isValidate: false,
    });
    const [loading, setLoading] = useState(false);

    const clearInput = () => {
        setFormFields({
            name: undefined,
            email: undefined,
            phoneNumber: {
                countryCode: '+65',
                number: undefined,
            },
            isValidate: false,
        });
        setLoading(false);
    };

    const onSubmit = () => {
        setFormFields({
            ...formFields,
            isValidate: true,
        });
        if (
            !formFields.name ||
            formFields.name.trim() === '' ||
            !formFields.email ||
            !emailValidation(formFields.email) ||
            !formFields.phoneNumber
        ) {
            return;
        }
        setFormFields({
            ...formFields,
            isValidate: false,
        });
        if (UUID) {
            setLoading(true);
            Apis.inviteReferral(UUID, {
                name: formFields.name,
                email: formFields.email,
                phoneNumber: formFields.phoneNumber,
            })
                .then(() => {
                    dispatch(
                        MessageActions.showMessage({
                            error: false,
                            text: 'Referral logged successfully. A member of our team will reach out soon!',
                        }),
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    clearInput();
                });
        }
    };

    const form = useMemo(() => {
        const onFieldChange = (data: { name: string; value?: number | string | PhoneNumberInput }) => {
            const { name, value } = data;
            let obj = { ...formFields };
            if (name) {
                obj[name] = (value as string) || '';
            }
            setFormFields(obj);
        };
        return (
            <div className="md:w-4/5 flex flex-col justify-center py-4">
                <div className="pb-2">
                    <NormalInput
                        className="bg-[#E1EBF8] border-0 border-b border-[#B9B9B9]"
                        value={formFields.name}
                        name="name"
                        title="Name"
                        onChange={onFieldChange}
                        isRequired
                    />
                    {formFields.isValidate && (!formFields.name || formFields.name.trim() === '') && (
                        <span className="common_error">Please enter name </span>
                    )}
                </div>
                <div className="pb-2">
                    <NormalInput
                        className="bg-[#E1EBF8] border-0 border-b border-[#B9B9B9]"
                        value={formFields.email}
                        name="email"
                        title="Email Address"
                        onChange={onFieldChange}
                        isRequired
                    />
                    {formFields.isValidate && !emailValidation(formFields.email) && (
                        <span className="common_error">Please enter valid email</span>
                    )}
                </div>
                <div>
                    <PhoneNumber
                        className="bg-[#E1EBF8] border-b border-[#B9B9B9]"
                        bgGrey={true}
                        name="phoneNumber"
                        title="Contact Number"
                        value={formFields.phoneNumber}
                        isRequired
                        onChange={onFieldChange}
                    />
                    {formFields.isValidate && !formFields.phoneNumber.number && (
                        <span className="common_error">Please enter phone no</span>
                    )}
                </div>
            </div>
        );
    }, [formFields]);

    return (
        <div className="md:border md:border-[#E1EBF8] flex flex-col justify-center items-start px-4 py-4 md:px-8 md:py-8">
            <p className="text-[30px] md:text-[40px] text-[#13223E] font-[WorkSans-Semibold]">REFER NOW</p>
            {form}
            <div className="py-4 md:w-3/5 ">
                <LinkButton title="Submit" loading={loading} onClick={onSubmit} isArrow size="sm" />
                {/* <HSButton className="w-full" title="Submit" onClick={onSubmit} isArrow={true} loading={loading} /> */}
            </div>
            <p className="text-xs md:w-3/4 text-justify text-[#747474] font-[Lato]">
                By submitting this form, you confirm, represent and warrant that you have obtained consent
                from the person named in this form for Helicap to contact him/her to promote Helicap.
                You also agree to our Terms of Use and Privacy Policy for the purpose of the
                Referral Program and  authorise Helicap to share that you have referred him/her.{' '}
                {/* <a
                    href={`${process.env.REACT_APP_LANDING_WEB_URL}/terms-of-service`}
                    rel="noreferrer"
                    className="text-[#20222B] Lato-Semibold"
                >
                    Terms of Use
                </a>{' '}
                and{' '}
                <a
                    href={`${process.env.REACT_APP_LANDING_WEB_URL}/privacy-policy`}
                    rel="noreferrer"
                    className="text-[#20222B] Lato-Semibold"
                >
                    Privacy Policy
                </a>{' '}
                for the purpose of the Referral Program and authorise Helicap to share that you have referred him/her. */}
            </p>
        </div>
    );
};

export default Section2Form;

interface FormField {
    [k: string]: string | boolean | PhoneNumberInput | undefined;
    name?: string;
    email?: string;
    phoneNumber: PhoneNumberInput;
    isValidate: boolean;
}
